import * as API from 'aws-amplify/api';
import { ConsoleLogger as Logger } from 'aws-amplify/utils';
import { notification } from 'antd';
import moment from 'moment';

import { createErrorMessage, getDefaultFunctions } from './globalStateHelper';
import { getGasDay } from '../utils/gasday';
import {
  MAX_DAYS_IN_RANGE,
  RESOLUTIONS,
} from '../constants/deliveries';

const log = new Logger('context:deliveries');
const NOW = moment.utc();

async function updateBiogasDeliveries(
  start = getGasDay(NOW),
  end = getGasDay(NOW.clone().add(MAX_DAYS_IN_RANGE, 'days')),
  resolution = RESOLUTIONS.DAY,
) {
  try {
    this.setState({ biogasDeliveriesLoading: true });
    const { selectedMarketPartyId } = this.state;
    const url = `/marketparties/${selectedMarketPartyId}/biogasdeliveries`;
    const options = {
      queryParams: {
        start,
        end,
        resolution,
      },
    };
    const { body } = await API.get({
      apiName: 'FINTSO',
      path: url,
      options,
    }).response;
    const { items: biogasDeliveries } = await body.json();

    this.setState({ biogasDeliveries });
    log.info('biogasDeliveries updated with data:', biogasDeliveries);
  } catch (error) {
    const description = await createErrorMessage(error);
    const { t } = this.props;
    this.setState({ biogasDeliveries: [] });
    notification.error({
      className: 'notification-error',
      message: t('common.notifications.errorFetchingDeliveries'),
      description,
    });
    log.error('error updating biogasDeliveries:', description);
  } finally {
    this.setState({ biogasDeliveriesLoading: false });
  }
}

async function updateDeliveries(
  start = getGasDay(NOW),
  end = getGasDay(NOW.clone().add(MAX_DAYS_IN_RANGE, 'days')),
  resolution = RESOLUTIONS.DAY,
) {
  try {
    this.setState({ loadingDeliveries: true });
    const { selectedMarketPartyId } = this.state;
    const deliveriesUrl = `/marketparties/${selectedMarketPartyId}/deliveries`;
    const options = {
      queryParams: {
        start,
        end,
        resolution,
      },
    };
    const { body } = await API.get({
      apiName: 'FINTSO',
      path: deliveriesUrl,
      options,
    }).response;
    const { items: deliveries } = await body.json();

    this.setState({ deliveries });
    log.info('deliveries updated with data:', deliveries);
  } catch (error) {
    const description = await createErrorMessage(error);
    const { t } = this.props;

    this.setState({ deliveries: [] });
    notification.error({
      className: 'notification-error',
      message: t('common.notifications.errorFetchingDeliveries'),
      description,
    });
    log.error('error fetching deliveries:', description);
  } finally {
    this.setState({ loadingDeliveries: false });
  }
}

async function updateDeliveryEstimates(start, end) {
  try {
    this.setState({ loadingDeliveryEstimates: true });
    const { selectedMarketPartyId } = this.state;
    const deliveryEstimatesUrl = `/marketparties/${selectedMarketPartyId}/deliveries/estimates`;
    const options = {
      queryParams: {
        start,
        end,
      },
    };
    const { body } = await API.get({
      apiName: 'FINTSO',
      path: deliveryEstimatesUrl,
      options,
    }).response;
    const { items: newEstimates } = await body.json();

    const { deliveryEstimates: oldEstimates } = this.state;

    const deliveryEstimates = [
      ...oldEstimates,
      ...newEstimates,
    ];

    this.setState({ deliveryEstimates });
    log.info('delivery estimates updated with data:', deliveryEstimates);
  } catch (error) {
    const description = await createErrorMessage(error);
    const { t } = this.props;

    this.setState({ deliveryEstimates: [] });
    notification.error({
      className: 'notification-error',
      message: t('common.notifications.errorFetchingDeliveryEstimates'),
      description,
    });
    log.error('error fetching delivery estimates:', description);
  } finally {
    this.setState({ loadingDeliveryEstimates: false });
  }
}

const functions = {
  updateBiogasDeliveries,
  updateDeliveries,
  updateDeliveryEstimates,
};

const deliveriesContext = {
  biogasDeliveries: [],
  biogasDeliveriesLoading: false,
  deliveries: [],
  loadingDeliveries: false,
  deliveryEstimates: [],
  loadingDeliveryEstimates: false,
  ...getDefaultFunctions(functions),
};

const deliveries = {
  ...deliveriesContext,
  ...functions,
};

export {
  deliveriesContext,
  deliveries,
};
